import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import TeamRezyPlatform from './App';
import MarketingHomepage from './components/marketing/MarketingHomepage.jsx';
import DeleteAccountPage from './components/pages/UserPages/DeleteAccountPage.jsx';
import VenueResponsePage from './components/pages/BookingPages/VenueResponsePage.jsx';
import { isAppDomain, redirectToApp } from './config/domains';

/**
 * AppRouter handles subdomain-based routing
 * - app.teamrezy.com -> Main application
 * - teamrezy.com (or any other subdomain) -> Marketing site
 */
const AppRouter = () => {
  // If on app subdomain, show the main application
  if (isAppDomain()) {
    return (
      <BrowserRouter>
        <Routes>
          {/* Venue response page - public, no auth required */}
          <Route path="/venue-response/:token" element={<VenueResponsePage />} />

          {/* All other routes go to the main app */}
          <Route path="*" element={<TeamRezyPlatform />} />
        </Routes>
      </BrowserRouter>
    );
  }

  // Otherwise, show the marketing site with routing
  return (
    <BrowserRouter>
      <Routes>
        {/* Marketing homepage */}
        <Route path="/" element={<MarketingHomepage />} />

        {/* Login route - redirects to app subdomain */}
        <Route
          path="/login"
          element={<RedirectToApp path="/login" />}
        />

        {/* Register route - redirects to app subdomain */}
        <Route
          path="/register"
          element={<RedirectToApp path="/register" />}
        />

        {/* Delete Account page - public form for data deletion requests */}
        <Route
          path="/delete-account"
          element={<DeleteAccountPage />}
        />

        {/* Catch all - show marketing homepage */}
        <Route path="*" element={<MarketingHomepage />} />
      </Routes>
    </BrowserRouter>
  );
};

/**
 * Component to redirect to the app subdomain
 */
const RedirectToApp = ({ path = '/' }) => {
  React.useEffect(() => {
    redirectToApp(path);
  }, [path]);
  
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-navy-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to app...</p>
      </div>
    </div>
  );
};

export default AppRouter;